import { useState, useContext } from 'react'
import { useMutation } from "@apollo/client";
import { useToast } from "@chakra-ui/react";
import { GET_ADDITIONAL_CREDITS } from '../../graphql/mutations';
import { PublisherAndUserContext } from '../../contexts/PublisherAndUserContext';
import {edshopBuilderUrl} from"../../config"

export const useCreditPackCard = () => {
    const { user, publisher } = useContext(PublisherAndUserContext);
    const [loading, setLoading] = useState(false);
    const toast = useToast();

    const [getAdditionalCredits] = useMutation(GET_ADDITIONAL_CREDITS, {
        onCompleted: (data) => {
            window.open(data.edshopifyCheckoutAdditionalCredits.url, "_self")
        },
        onError: () => {
            toast({
                position: "top-right",
                title: "Something went wrong. Please try again after sometime.",
                status: "error",
                duration: 3000,
                isClosable: true,
            });
        },
    });

    const buyCredits = (credits) => {
        setLoading(true)
        getAdditionalCredits({
            variables: {
                data: {
                    ...(publisher?.subscriptionInfo?.stripeCustomerId ? { customerId: publisher?.subscriptionInfo?.stripeCustomerId } : {}),
                    successUrl: `${edshopBuilderUrl}/success`,
                    cancelUrl: `${edshopBuilderUrl}/fail`,
                    customer_email: user.email,
                    metadata: JSON.stringify({ publisherId: publisher.id, credits: credits, isBuyCredits: true })
                },
                where: {
                    id: publisher.id
                }
            }
        })
    }

    return {
        buyCredits,
        loading
    }
}
